import ExcelJS from 'exceljs';
import { notifyWarning } from '../utils/notifications';


const ExcelsButtons = ({
    columns,
    data = [],
    excludeColumns = ['acciones', 'actions']
}) => {

    /*
    const exportTemplate = async () => {


        try {
            // Agrega al inicio del archivo (ESModule):

            // Reemplaza en el lugar del placeholder:
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Plantilla');

            const headers = []

            for (const key in columns) {
                headers.push(key);
            }

            // Filtrar columnas que no se desean en la plantilla
            const filteredHeaders = headers.filter(h =>
                !excludeColumns.some(exc => h.toLowerCase().includes(exc.toLowerCase()))
            );

            // Configurar columnas a partir de las keys obtenidas
            worksheet.columns = filteredHeaders.map((h) => ({
                header: h,
                key: h,
                width: 25
            }));

            // Estilo de cabecera
            const headerRow = worksheet.getRow(1);
            headerRow.font = { bold: true };
            headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.views = [{ state: 'frozen', ySplit: 1 }];

            // Ejemplo de fila (opcional): dejar filas vacías para guía
            const exampleRow = {};
            filteredHeaders.forEach((h) => (exampleRow[h] = ''));
            worksheet.addRow(exampleRow);

            // Generar buffer y forzar descarga en navegador
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
            a.download = `plantilla_${timestamp}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Error generando plantilla Excel:', err);
        }
    };
    */

    const exportData = async () => {

        // Aqui vamos a validar que haya datos para exportar y no generar un archivo vacio
        if (!data || data.length === 0) {
            notifyWarning('No hay datos para exportar.');
            return;
        }

        try {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Datos');

            // Normalize columns prop into array of { key, header, accessor? }
            const normalized = [];

            if (Array.isArray(columns)) {
                for (const col of columns) {
                    if (typeof col === 'string') {
                        normalized.push({ key: col, header: col });
                        continue;
                    }
                    const key = col.accessor || col.key || col.id || col.field || col.name || (col.Header && String(col.Header)) || null;
                    const header = col.header || col.Header || col.title || col.name || (typeof col === 'string' ? col : key) || key;
                    if (key) normalized.push({ key, header, accessor: col.accessor || col.getValue || null });
                }
            } else if (columns && typeof columns === 'object') {
                for (const k in columns) {
                    const val = columns[k];
                    const header = typeof val === 'string' ? val : (val.header || val.label || String(val || k));
                    normalized.push({ key: k, header, accessor: typeof val === 'object' ? (val.accessor || val.getValue) : null });
                }
            }

            // Filtrar columnas que no se desean en la plantilla
            const dataColumns = normalized.filter(col => {
                const key = col.key?.toLowerCase() || '';
                const header = col.header?.toLowerCase() || '';
                return !excludeColumns.some(exc => {
                    const excLower = exc.toLowerCase();
                    return key.includes(excLower) || header.includes(excLower);
                });
            });

            // Helper to read nested values by path (supports dot and bracket)
            const getValueByPath = (obj, path) => {
                if (obj == null) return undefined;
                if (!path) return undefined;
                if (typeof path === 'function') return path(obj);
                const parts = String(path).replace(/\[(\w+)\]/g, '.$1').split('.');
                let res = obj;
                for (const p of parts) {
                    if (res == null) return undefined;
                    res = res[p];
                }
                return res;
            };

            // Setup worksheet columns
            worksheet.columns = dataColumns.map((c) => ({
                header: c.header || c.key,
                key: c.key,
                width: 25
            }));

            // Header style & freeze
            const headerRow = worksheet.getRow(1);
            headerRow.font = { bold: true };
            headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.views = [{ state: 'frozen', ySplit: 1 }];

            // Populate data rows based on normalized columns
            for (const row of data || []) {
                const rowObj = {};
                for (const col of dataColumns) {
                    let value;
                    if (typeof col.accessor === 'function') {
                        try {
                            value = col.accessor(row);
                        } catch {
                            value = undefined;
                        }
                    } else {
                        value = getValueByPath(row, col.key);
                    }

                    // Format common types
                    if (value instanceof Date) {
                        value = value.toISOString();
                    } else if (typeof value === 'object' && value !== null) {
                        // Keep primitives, stringify objects/arrays
                        value = JSON.stringify(value);
                    }

                    rowObj[col.key] = value != null ? value : '';
                }
                worksheet.addRow(rowObj);
            }

            // Optionally add autofilter
            if (worksheet.columnCount > 0) {
                worksheet.autoFilter = {
                    from: {
                        row: 1,
                        column: 1
                    },
                    to: {
                        row: 1,
                        column: worksheet.columnCount
                    }
                };
            }

            // Export
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
            a.download = `export_datos_${timestamp}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Error exportando datos a Excel:', err);
        }

    };

    return (
        <div className='excel-group'>
            <button
                type="button"
                className='btn btn-success excel-btn'
                onClick={exportData}
                aria-label="Descargar Excel"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor" style={{ verticalAlign: 'middle', marginRight: 8 }}>
                    <path d="M12 16l4-5h-3V4h-2v7H8l4 5z" />
                    <path d="M20 18v2H4v-2H2v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2h-2z" />
                </svg>
                Descargar Excel
            </button>
        </div>
    );
};

export default ExcelsButtons;